<h5 *ngIf="getTitle()" class="col-title">{{title}}</h5>
<div *ngIf="getTitle()" class="title-divider"></div>
<div style="display: flex;" *ngIf="this.getIsSummaryType()" class="{{this.getClass()}}">
  <div style="width: 99%;">
    <ng-container #target></ng-container>
  </div>
  <div *ngIf="this.getIsSummaryType() && this.getCurrentCol() !== this.getColCount()
        && this.getShowBorders() && !isSmallSize && !isExtraSmall" class="summary-line"></div>
</div>
<div *ngIf="!this.getIsSummaryType()" class="{{this.getClass()}}">
  <ng-container #target></ng-container>
</div>

<div class="w-100" *ngIf="this.getHasBottomDivider() && !isMediumSize">
  <div class="bottom-line-summary w-100"></div>
</div>


